import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  careersJobSingleData: null,
  isActive:false,
};

export const getCareersJobSingle = createAsyncThunk(
  "careersJobSingle/getCareersJobSingle",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`page/career/jobs/single`,{params});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const careersJobSingleSlice = createSlice({
  name: "careersJobSingle",
  initialState,
  reducers: {},
  extraReducers: {
    [getCareersJobSingle.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getCareersJobSingle.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.careersJobSingleData = action.payload?.data;
      state.isActive = true;
    },
    [getCareersJobSingle.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default careersJobSingleSlice.reducer;
